import { Action, ActionType } from '../actions/actionTypes';
import STORE from '../store';
import { AppStore } from '../types';

// eslint-disable-next-line default-param-last
const reducer = (state = STORE.app, action: Action): AppStore => {
    switch (action.type) {
        case ActionType.SET_USER:
            return { ...state, user: action.payload };
        case ActionType.SET_USERS:
            return { ...state, users: action.payload };
        case ActionType.SET_PRODUCT_CATEGORIES:
            return { ...state, productCategories: action.payload };
        case ActionType.REMOVE_NOTIFICATION:
            return {
                ...state,
                notifications: state.notifications.filter(
                    ({ key }) => key !== action.payload
                )
            };
        case ActionType.ENQUEUE_NOTIFICATION:
            return {
                ...state,
                notifications: state.notifications.concat(action.payload)
            };
        case ActionType.SET_CATEGORY_IMAGES:
            return { ...state, categoryImages: action.payload };
        case ActionType.SET_TABLES:
            return { ...state, tables: action.payload };
        case ActionType.SET_STORE_CONFIGURATION:
            return { ...state, storeConfiguration: action.payload };
        case ActionType.SET_AVAILABLE_LANGUAGES:
            return { ...state, availableLanguages: action.payload };
        case ActionType.SET_PRODUCTS:
            return { ...state, products: action.payload };
        case ActionType.SET_LOADING:
            return { ...state, loading: action.payload };
        case ActionType.SET_CLOSURES:
            return { ...state, closures: action.payload };
        default:
            return state;
    }
};

export default reducer;
